import { Directive,ElementRef,HostBinding, Input } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { AppSettings } from '../_models/app.settings';

@Directive({
	selector: '[secured]'
})
export class Secured {
	@HostBinding('hidden')
	hideRouterLink:boolean = false;
	@Input() secured: any;

	constructor(private eltRef:ElementRef, private localStorage:LocalStorageService) {
	}

	ngAfterViewInit() {
		var esconder = true;
		var user:any = this.localStorage.get('user');
    	var accesos:any = user ? user.accesos : false;
		if(accesos){

			for(let i = 0; i < accesos.length && esconder == true; i++ ){
				let acceso = parseInt(accesos[i].permisos);
				esconder = (acceso & AppSettings.permisos[this.secured]) == 0;
			}

		}
		this.hideRouterLink = esconder;
	}
}


// WEBPACK FOOTER //
// ./src/app/_directives/secured.directive.ts